import { render, staticRenderFns } from "./latest-answers.vue?vue&type=template&id=696c792d&scoped=true&"
import script from "./latest-answers.vue?vue&type=script&lang=js&"
export * from "./latest-answers.vue?vue&type=script&lang=js&"
import style0 from "./latest-answers.vue?vue&type=style&index=0&id=696c792d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696c792d",
  null
  
)

export default component.exports